// components/PaginationTab.jsx
import React from "react";
import {
  PaginationLeftArrow,
  PaginationRightArrow,
  DownArrowSelect,
} from "../assets/icons";

const PaginationTab = ({
  currentPage = 1,
  pageSize = 10,
  totalCount = 0,
  totalPages = 0,
  onPageChange = () => {},
  onPageSizeChange = () => {},
  pageSizeOptions = [10, 20, 30, 50, 100],
  showTotal = true,
  className = "",
}) => {
  const goToPage = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    onPageChange(pageNum);
  };

  const handlePageSizeChange = (event) => {
    onPageSizeChange(Number(event.target.value));
    onPageChange(1);
  };

  // Generate page numbers with ellipsis
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push("...");
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <div
      className={`flex justify-end gap-2 flex-wrap items-center mt-6 ${className}`}
    >
      {showTotal && (
        <p className="text-sub_span mb-0 !font-medium text-black">
          Total {totalCount}
        </p>
      )}

      <div className="flex items-center space-x-2">
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
          className="border-none outline-none disabled:opacity-50"
        >
          {PaginationLeftArrow}
        </button>

        {getPageNumbers().map((pageNum, index) => (
          <button
            key={index}
            onClick={() => typeof pageNum === "number" && goToPage(pageNum)}
            disabled={pageNum === "..."}
            className={`flex items-center justify-center rounded-[8px] text-body-span w-[28px] h-[28px] text-center border-[1px] ${
              currentPage === pageNum
                ? "text-blue-100 border-[#4285F4]"
                : "text-gray-100 border-[#5c5b62]"
            } ${pageNum === "..." ? "cursor-default border-none" : ""}`}
          >
            {pageNum}
          </button>
        ))}

        <button
          className="border-none outline-none disabled:opacity-50"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {PaginationRightArrow}
        </button>
      </div>

      <div className="flex items-center relative">
        <select
          value={pageSize}
          onChange={handlePageSizeChange}
          className="w-full text-sub_span text-black border-2 border-[#FAFAFA] rounded-[16px] p-2 pl-3 pr-6 outline-none appearance-none"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size} / page
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
          {DownArrowSelect}
        </div>
      </div>
    </div>
  );
};

export default PaginationTab;
